import React from 'react';
import { dateOptions } from '../../../utils/dates';

const FlushSummary = ({ companyName, startDate, endDate, totalFlushes, totalGallonsUsed }) => {
	const formatDate = (value) => {
		if (!value) return '';
		const date = new Date(value);
		if (Number.isNaN(date.getTime())) return '';
		return date.toLocaleDateString('en-US', dateOptions);
	};

	const gallons = Number(totalGallonsUsed);
	const formattedGallons = Number.isFinite(gallons)
		? `${gallons.toLocaleString('en-US')}`
		: '--';
	const formattedFlushes = Number.isFinite(totalFlushes)
		? `${totalFlushes.toLocaleString('en-US')}`
		: '--';

	return (
		<tr>
			<td>
				<div className="flush-summary">
					<div className="flush-summary-info">
						<div className="flush-summary-detail">
							<label>Start Date:</label>
							<span>{formatDate(`${startDate}T00:00`) || '--'}</span>
						</div>
						<div className="flush-summary-detail">
							<label>End Date:</label>
							<span>{formatDate(`${endDate}T23:59`) || '--'}</span>
						</div>
					</div>
					<div className="flush-summary-stats">
						<div className="flush-summary-count">
							<div className="flush-summary-count-title" style={{ textAlign: 'center' }}>
								<span>Total Flushes</span>
							</div>
							<div className="flush-summary-count-value" style={{ textAlign: 'center' }}>
								<span style={{ fontSize: '1.8rem', fontWeight: 700 }}>{formattedFlushes}</span>
							</div>
						</div>
						<div className="flush-summary-gallons">
							<div className="flush-summary-gallons-title" style={{ textAlign: 'center' }}>
								<span>Total Gallons Used</span>
							</div>
							<div className="flush-summary-gallons-value" style={{ textAlign: 'center' }}>
								<span style={{ fontSize: '1.8rem', fontWeight: 700 }}>{formattedGallons}</span>
							</div>
						</div>
					</div>
				</div>
			</td>
		</tr>
	);
};

export default FlushSummary;
